import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";
import { useNotify } from "./NotificationProvider";
import { useAuth } from "./AuthProvider";

export const ReactQueryProvider = ({ children }: { children: ReactNode }) => {
  const notify = useNotify();
  const auth = useAuth();
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 3 * 60 * 1000,
        gcTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error: any) => {
          if (error?.response?.status === 401) {
            console.error("Unauthorized access, not retrying and logging out.");
            auth.logout();
            return false;
          }
          return failureCount < 2;
        },
        retryDelay: (attempt) => Math.min(2000 * 2 ** attempt, 30000),
      },
      mutations: {
        retry: 0,
        onError: (error: any) => {
          if (error?.response?.status === 401) {
            console.error("Unauthorized access during mutation, logging out.");
            auth.logout();
          }

          notify.error({ message: error?.message || "Something went wrong" });
        },
        onSuccess: () => {
          notify.success({ message: "Operation successful" });
        },
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
